import React, {useState} from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import {makeStyles} from '@material-ui/styles';
import {
    Card,
    CardContent,
    Grid,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    root: {},
    formControl: {
        marginRight: theme.spacing(1),
    },
    select: {},
    icon: {
        marginRight: '12px',
    },
    selectEmpty: {
        marginTop: theme.spacing(2),
    },
}));

const Filter = props => {
    const {className, dealList, onChange, ...rest} = props;
    const classes = useStyles(props);

    const [value, setValue] = useState('');

    // Deal 선택
    const handleChange = event => {
        const selected = event.target.value;

        if (!selected) return;

        const {code, name} = dealList.find(data => data.code === selected);

        setValue(code);

        onChange({
            code: code,
            name: name
        });
    };

    return (
        <Card
            {...rest}
            className={clsx(classes.root, className)}
        >
            <CardContent>
                <Grid
                    alignItems="flex-end"
                    container
                    spacing={2}
                >
                    <Grid
                        item
                        md={12}
                        sm={12}
                        xs={12}
                    >
                        <FormControl
                            className={classes.formControl}
                            fullWidth
                        >
                            <InputLabel
                                id="deal-label"
                                shrink
                            >Deal</InputLabel>
                            <Select
                                classes={{
                                    icon: classes.icon,
                                }}
                                displayEmpty
                                id="deal"
                                labelId="deal-label"
                                value={value}
                                onChange={handleChange}
                            >
                                <MenuItem value="">
                                    <em>select deal</em>
                                </MenuItem>
                                {dealList.map(category => (
                                    <MenuItem
                                        key={category.code}
                                        value={category.code}
                                    >
                                        {category.name}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
};

Filter.propTypes = {
    dealList: PropTypes.array,
    onChange: PropTypes.func,
    className: PropTypes.string,
};

export default Filter;
